import {Bars} from 'react-loader-spinner'
import axios from 'axios';
import React, {useContext, useEffect, useState} from 'react';
import ClusterChart from '../../Chart/ClusterChart';
import {authContext} from '../../Context/Authentication/authContext';
import {dataScienceURL} from '../../config';
import {generateBarChartData, PROPERTY_TYPE_LABELS} from '../../Helpers/helpers'


const PropertyType = (props) => {
  const {state}: any = useContext(authContext);
  const [chartData, setChartData]: any = useState(null);
  const [chartLabel, setChartLabel]: any = useState(PROPERTY_TYPE_LABELS);
  const {type} = props


  useEffect(() => {
    getPropertyTypes(type);
  }, [state.filters.city]);

  useEffect(() => {
    getPropertyTypes(type);
  }, [state.filters.zipcodePrediction]);

  useEffect(() => {
    getPropertyTypes(type);
  }, [state.filters.msa]);


  const getAPIEndpoint = (type) => {
    if (type === 'city') {
      return `${dataScienceURL}getPropertyTypeByCity?state=${state.filters.state}&city=${state.filters.city[0]}`
    } else if (type === 'zipcode') {
      let zip = state.filters.zipcodePrediction.length > 0 ? state.filters.zipcodePrediction[0] : state.filters.zipcodePrediction
      zip = zip.split('_')
      console.log(zip)
      return `${dataScienceURL}getPropertyTypeByZip?state=${state.filters.state}&zipcode=${zip[0]}`
    } else if (type === 'metroarea') {
      let msa = state.filters.msa.length > 0 ? state.filters.msa[0] : state.filters.msa
      return `${dataScienceURL}getPropertyTypeByMetro?state=${state.filters.state}&metroarea=${msa.name}`
    }
  }

  const getPropertyTypes = async (type) => {
    try {
      const response = await axios.get(getAPIEndpoint(type));
      const resp = response.data?.list
      console.log(resp)
      const data = generateBarChartData(resp);
      console.log(data)
      setChartData(data);
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className='population-main'>
      {chartData === null ? (
        <div className='daysOnMarket-main__chartContainer__isLoading'>
          <Bars height='400' ariaLabel='bars-loading' wrapperClass='tab-spinner-progress-bar' visible={true}/>
        </div>
      ) : chartData?.length ? (
        <>
          <div className='population-main__text'>Property Distribution</div>
          <ClusterChart
            chartData={chartData}
            info={chartLabel}
          />
        </>
      ) : (
        <div className='daysOnMarket-main__chartContainer__noData'>
          No Data Available
        </div>
      )}
    </div>
  );
};

export default React.memo(PropertyType);
